<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <div class="login-wrap">
      <div class="login-title">密码登录</div>
      <div class="input-wrap" :style="errorInfo.mobileWrapObj">
        <img src="../../../assets/img/login_btn_user.png" alt="">
        <input type="text" placeholder="请输入账号" v-model.trim="nickname" @blur="checkNickname">
        <img v-show="nickname" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('nickname')">
      </div>
      <div class="input-tip" :style="errorInfo.mobileTipObj">
        <Icon type="md-alert" size="24" color="#FF9734" />
        <span class="tip-content">{{errorInfo.mobileTip}}</span>
      </div>
      <div class="input-wrap last" :style="errorInfo.passwordWrapObj">
        <img src="../../../assets/img/login_btn_password.png" alt="">
        <input type="password" placeholder="请输入密码" v-model.trim="password" @input="checkPassword">
        <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('password')">
      </div>
      <div class="input-tip" :style="errorInfo.passwordTipObj">
        <Icon type="md-alert" size="24" color="#FF9734" />
        <span class="tip-content">{{ errorInfo.passwordTip }}</span>
      </div>
      <div class="operate-wrap">
        <div class="forget-pwd" @click="toForgetPwd">忘记密码？</div>
      </div>
      <div class="to-login" @click="doLogin">登录</div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/h5/Nav.vue'
  import { Spin, Icon } from 'view-design'
  import { getToken, getHasPackage } from '@/utils/auth'
  import { login } from '@/api/user'
  export default {
    name: 'Login',
    components: {
      Nav,
      Spin,
      Icon
    },
    data() {
      return {
        nickname: '',
        password: '',
        code: '',
        isLogin: getToken() ? true : false, //是否登陆
        errorInfo: {
          mobileTip: '',
          passwordTip: '',
          mobileTipObj: {
            display: 'none'
          },
          passwordTipObj: {
            display: 'none'
          },
          mobileWrapObj: {
            border: '1px solid #E8E8E8'
          },
          passwordWrapObj: {
            border: '1px solid #E8E8E8' // ff4f76
          }
        }
      }
    },
    mounted:function(){
      if(this.isLogin){
        this.$toast.success('您已登录！')
        setTimeout(function(){
          //获取用户信息
          this.$store.dispatch('user/getInfo').then((response) => {
            this.$router.push({
              path: '/h5/promotion/home'
            })
          }).catch(() => {})
        },500)
      }
    },
    methods: {
      //清除文本框
      clear(val) {
        this[val] = ''
      },
      //监听密码
      checkPassword() {
        var isValidate = true
        var tip = ''
        if (this.password === '') {
          tip = '请填写密码'
          isValidate = false
          return this.handelErrorTip(isValidate, 1, tip)
        }
        if (!(this.password.length >= 6)) {
          tip = '密码长度错误'
          isValidate = false
          return this.handelErrorTip(isValidate, 1, tip)
        }
        tip = ''
        isValidate = true
        return this.handelErrorTip(isValidate, 1, tip)
      },
      //监听昵称或手机号
      checkNickname() {
        var isValidate = true
        var tip = ''
        if (this.nickname === '') {
          tip = '请填写手机号'
          isValidate = false
          return this.handelErrorTip(isValidate, 0, tip)
        }
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.nickname))) {
          tip = '手机号格式错误'
          isValidate = false
          return this.handelErrorTip(isValidate, 0, tip)
        }
        isValidate = true
        tip = ''
        return this.handelErrorTip(isValidate, 0, tip)
      },
      handelErrorTip: function(isValidate, type, tip) {
        if (type == 0) {
          if (isValidate === false) {
            this.errorInfo.mobileTip = tip
            this.errorInfo.mobileTipObj.display = 'flex'
            this.errorInfo.mobileWrapObj.border = '1px solid #FF9734'
          } else {
            this.errorInfo.mobileTip = ''
            this.errorInfo.mobileTipObj.display = 'none'
            this.errorInfo.mobileWrapObj.border = '1px solid #E8E8E8'
          }
        } else {
          if (isValidate === false) {
            this.errorInfo.passwordTip = tip
            this.errorInfo.passwordTipObj.display = 'flex'
            this.errorInfo.passwordWrapObj.border = '1px solid #FF9734'
          } else {
            this.errorInfo.passwordTip = ''
            this.errorInfo.passwordTipObj.display = 'none'
            this.errorInfo.passwordWrapObj.border = '1px solid #E8E8E8'
          }
        }
        return isValidate
      },
      toForgetPwd() {
        this.$router.push('/h5/resetPwd')
      },
      doLogin() {
        var isValidate = this.allValidate()
        if (isValidate === false) {
          return
        }
        this.loading = true
        var loginFormData = {
          mobile: this.nickname,
          password: this.password
        }

        this.$store.dispatch('user/login', loginFormData).then((response) => {
          this.loading = false
          this.isLogin = true
          this.nickname = this.password = ''
          this.$toast.success('登录成功')
          //获取用户信息
          this.$store.dispatch('user/getInfo').then((response) => {
            // 如果之前用户从公众号那边入驻进来的
            let isGoOfficial = this.$store.getters.isGoOfficial
            if(isGoOfficial == 1){
              let param = this.$route.param
              // 是否购买了套餐
              let hasPackage =   getHasPackage() === 'true' ? true : false
              if(hasPackage){
                this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
                this.$router.push({
                  path: '/h5/official/statistics',
                  query:param
                })
              }else{
                this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
                // 便于sildeNav 触发change数据
                this.$router.push({
                  path: '/h5/official/dialog',
                  query:param
                })
              }
            }else{
              this.$router.push({
                path: '/h5/promotion/home',
                query: this.otherQuery
              })
            }
          }).catch(() => {})
        }).catch(() => {
          this.loading = false
        })
      },
      allValidate() {
        return (this.checkNickname() && this.checkPassword())
      }
    }
  }
</script>

<style lang="less" scoped>
  .login-wrap {
    font-family: Alibaba-PuHuiTi-R;
    padding: 70px 30px;
    .login-title {
      font-size: 24px;
      color: #222222;
      text-align: left;
      padding-bottom: 20px;
    }
    .input-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 7px 15px 7px 10px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 2px;
      margin-top: 20px;
      img {
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      input {
        width: 90%;
        font-size: 15px;
        color: #222222;
        padding: 5px 5px 5px 10px;
        border: none;
      }
      input::-webkit-input-placeholder{
        font-size: 15px;
        color: #CCCCCC;
      }
    }
    .input-tip {
      margin-top: 8px;
      font-size: 12px;
      color: #FF9734;
      letter-spacing: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tip-content {
        margin-left: 3px;
        color: #FF9734;
      }
    }
    .hidden {
      display: none;
    }
  }
  ::-webkit-input-placeholder {
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  .operate-wrap {
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #555555;
    margin-top: 10px;
    width: 100%;
    overflow: hidden;
    .forget-pwd {
      float: right;
      cursor: pointer;
    }
    .to-register {
      float: left;
      cursor: pointer;
    }
  }
  .to-login {
    color: #FFFFFF;
    background: #FF8622;
    border-radius: 2px;
    margin-top: 22px;
    text-align: center;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/login/Index.vue